/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSchemaResponseModel } from '../../models/document-schema-response-model';

export interface ApiDocumentSchemasContractsSchemasGet$Plain$Params {
}

export function apiDocumentSchemasContractsSchemasGet$Plain(http: HttpClient, rootUrl: string, params?: ApiDocumentSchemasContractsSchemasGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchemaResponseModel>>> {
  const rb = new RequestBuilder(rootUrl, apiDocumentSchemasContractsSchemasGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentSchemaResponseModel>>;
    })
  );
}

apiDocumentSchemasContractsSchemasGet$Plain.PATH = '/api/DocumentSchemas/contracts-schemas';
